import React from "react";
import { ReactComponent as IconRefresh } from "@assets/Icons/IconRefresh.svg";
import { ReactComponent as IconArrowLeft } from "@assets/Icons/IconArrowLeft.svg";
import { ReactComponent as IconArrowRight } from "@assets/Icons/IconArrowRight.svg";

/**
 * Función auxiliar para mapear un string a un ícono.
 * Ajusta o agrega los que necesites.
 */
export function getIconByName(name: string) {
    switch (name) {
        case "refresh":
            return <IconRefresh />;
        case "arrowLeft":
            return <IconArrowLeft />;
        case "arrowRight":
            return <IconArrowRight />;
        default:
            return null;
    }
}
